import styles from './style.module.css'
import React from 'react'
// Creator : Team e - chanan
function MainButton({ children, onClick }) {
    return <>
        <button onClick={onClick} className={`${styles["addButton"]} btn`}>{children}</button>
    </>
}

export default MainButton